import "quill/dist/quill.snow.css";
import ReactQuill from "react-quill-new";

interface RichTextEditorProps extends ReactQuill.ReactQuillProps {
  className?: string;
  value: string;
  readOnly?: boolean;
  onChange?: (content: string) => void;
}

const RichTextEditor = ({
  value,
  onChange,
  readOnly,
  className = "flex flex-col container min-h-24",
  ...restProps
}: RichTextEditorProps) => {
  return (
    <ReactQuill
      className={className}
      theme="snow"
      onChange={onChange}
      value={value}
      readOnly={readOnly}
      {...restProps}
    />
  );
};

export default RichTextEditor;
